import React, { useEffect } from 'react';
import ChainOfThought from '../chat/chainOfThought';
import { useThinkingStream } from '../../hooks/wsThinkingStream';
import { useChat } from '../../context/chatContext';

interface Props {
  userId?: string | null;
  token?: string | null;
  chatId?: string | null;
  jobId?: string | null;
  title?: string;
  maxHeight?: number | string;
  hideAgents?: string[];
  defaultExpanded?: boolean;
}

const ThinkingStreamPanel: React.FC<Props> = ({
  userId,
  token,
  chatId,
  jobId,
  title,
  maxHeight,
  hideAgents,
  defaultExpanded
}) => {
  const { setIsLoading, isLoading, updateThoughtSteps, thoughtSteps, updateThinkingSteps, thinkingSteps } = useChat()
  const { readyState } = useThinkingStream({ userId, token, chatId, jobId }, isLoading, setIsLoading, updateThinkingSteps);
  //const isLoading = (readyState === WebSocket.OPEN);

/* useEffect(() => {
setIsLoading((readyState == WebSocket.CONNECTING || readyState == WebSocket.OPEN))
console.log('is loading websocket', (readyState == WebSocket.CONNECTING || readyState == WebSocket.OPEN))
},[readyState, steps]) */

useEffect(() => {
    if(thinkingSteps.length && thoughtSteps.length !== thinkingSteps.length && !isLoading) {
      updateThoughtSteps(thinkingSteps)
    }
}, [thinkingSteps, isLoading])
  return (
    <ChainOfThought
      steps={thinkingSteps}
      isLoading={isLoading}
      maxHeight={maxHeight}
      hideAgents={hideAgents}
      defaultExpanded={defaultExpanded}
      summaryText={(visible, loading) =>
        title ?? (visible.length > 0 && loading ? `Thought of ${visible.length} steps` : 'Enantio is thinking…')
      }
    />
  );
};

export default ThinkingStreamPanel;
